import { ReactElement } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@mui/icons-material/Search';
import RotateRightIcon from '@mui/icons-material/RotateRight';

import Input from '~/ui/components/inputs/Input';
import Button from '~/ui/components/common/Button';

import initialValues from './form/initialValues';
import { IProgramsListFilters } from '~/services/api/programs/types';
import styles from './Header.module.scss';

interface IProps {
  onSubmit: (filters: IProgramsListFilters) => void;
}

const Header = ({ onSubmit }: IProps): ReactElement => {
  const formMethods = useForm<IProgramsListFilters>({
    defaultValues: initialValues,
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item className={styles.nameInput}>
            <Input
              name="name"
              register={register}
              errors={errors}
              label="Name"
              placeholder="Search by Name"
            />
          </Grid>
          <Grid item xs />
          <Grid item>
            <Button variant="outlined" type="submit" color="primary" startIcon={<SearchIcon />}>
              Search
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              type="button"
              startIcon={<RotateRightIcon />}
              onClick={() => {
                reset(initialValues);
                onSubmit(initialValues);
              }}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};

export default Header;
